/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserCommunityMembershipResponse
 */
export interface GetUserCommunityMembershipResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUserCommunityMembershipResponse
     */
    community: string;
    /**
     * 
     * @type {number}
     * @memberof GetUserCommunityMembershipResponse
     */
    rankWithinCommunity: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserCommunityMembershipResponse
     */
    pointsEarnedForCommunity: number;
    /**
     * 
     * @type {string}
     * @memberof GetUserCommunityMembershipResponse
     */
    nftGroupingId: string;
}

/**
 * Check if a given object implements the GetUserCommunityMembershipResponse interface.
 */
export function instanceOfGetUserCommunityMembershipResponse(value: object): value is GetUserCommunityMembershipResponse {
    if (!('community' in value) || value['community'] === undefined) return false;
    if (!('rankWithinCommunity' in value) || value['rankWithinCommunity'] === undefined) return false;
    if (!('pointsEarnedForCommunity' in value) || value['pointsEarnedForCommunity'] === undefined) return false;
    if (!('nftGroupingId' in value) || value['nftGroupingId'] === undefined) return false;
    return true;
}

export function GetUserCommunityMembershipResponseFromJSON(json: any): GetUserCommunityMembershipResponse {
    return GetUserCommunityMembershipResponseFromJSONTyped(json, false);
}

export function GetUserCommunityMembershipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserCommunityMembershipResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'community': json['community'],
        'rankWithinCommunity': json['rankWithinCommunity'],
        'pointsEarnedForCommunity': json['pointsEarnedForCommunity'],
        'nftGroupingId': json['nftGroupingId'],
    };
}

export function GetUserCommunityMembershipResponseToJSON(json: any): GetUserCommunityMembershipResponse {
    return GetUserCommunityMembershipResponseToJSONTyped(json, false);
}

export function GetUserCommunityMembershipResponseToJSONTyped(value?: GetUserCommunityMembershipResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'community': value['community'],
        'rankWithinCommunity': value['rankWithinCommunity'],
        'pointsEarnedForCommunity': value['pointsEarnedForCommunity'],
        'nftGroupingId': value['nftGroupingId'],
    };
}

